import {
    XAxis,
    AreaChart,
    Area,
    Tooltip,
    ResponsiveContainer
} from "recharts";
import React, { useEffect, useState } from "react";
import ReportHelper from "../../../core/config/helpers/ReportHelper";
import { DateHelper } from "../../../core/config/helpers/DateHelper";
import { AccountController } from "../../../core/config/controllers/AccountController";

export default function UsersReport({ }) {
    const date = new Date();
    const [data, setData] = useState(
        [
            {
                novos_usuarios: 0,
                acessos: 0,
                year: 2025,
                month: 6,
            }
        ]
    );
    const [startDate, setStartDate] = useState(
        DateHelper.GetFirstDayOfMonth(date.getFullYear(), 0)
    );
    const [endDate, setEndDate] = useState(
        DateHelper.GetLastDayOfMonth(date.getFullYear(), 11)
    );
    const reportHelper = ReportHelper();

    useEffect(() => {
        loadReport();
    }, [startDate, endDate]);

    useEffect(() => {
        loadReport();
    }, [startDate, endDate]);

    async function loadReport() {
        AccountController.List(res => {
            let results = [];
            for (let user of res) {
                if (typeof user.created_time !== "string") {
                    const date = new Date(user.created_time?.seconds * 1000);
                    const access = new Date(user.created_time?.seconds * 1000);
                    const year = date.getFullYear();
                    const month = date.getMonth();
                    const key = `${year}-${month}`;
                    // console.log("Usuários", date);

                    results.push({
                        year: year,
                        month: month,
                        user: 1,
                        access: access,
                    });
                    // console.log("Usuários", user);
                }
            }

            // console.log("Usuários", res, results);
            process(results);
        })
    }

    function process(res) {
        let responses = reportHelper.base;
        for (let s of responses) {
            s.novos_usuarios = 0;
            s.acessos = 0;
        }
        for (let s of responses) {
            for (let i of res) {
                const startYear = new Date(startDate).getFullYear();
                if (ReportHelper().monthNames[i.month] === s.name && i.year === startYear) {
                    s.novos_usuarios++;
                }
            }
        }

        // console.log("Resultado", responses, res);
        setData(responses);
    }

    function processDate(year) {
        setStartDate(DateHelper.GetFirstDayOfMonth(year, 0));
        setEndDate(DateHelper.GetLastDayOfMonth(year, 11));
    }

    return (
        <div className="col-md-12" key={"ticketsReport"}>
            <div className="block block-rounded block-bordered">
                <ul className="nav nav-tabs nav-tabs-block align-items-center border-bottom">
                    <li className="nav-item">
                        <a
                            className="nav-link text-body-color active"
                            href="javascript:void(0)"
                        >
                            Usuários novos vs Acessos de usuários antigos
                        </a>
                    </li>
                    <li className="nav-item ml-auto">
                        <div className="block-options mr-3">
                            {date.getFullYear() - 2025 >= 2 ?
                                <button
                                    className="btn btn-dual"
                                    onClick={() => processDate(date.getFullYear() - 2)}
                                >
                                    {date.getFullYear() - 2}
                                </button>
                                : ""}
                            {date.getFullYear() - 2025 === 1 ?
                                <button
                                    className="btn btn-dual"
                                    onClick={() => processDate(date.getFullYear() - 1)}
                                >
                                    {date.getFullYear() - 1}
                                </button>
                                : ""}
                            <button
                                className="btn btn-dual"
                                onClick={() => processDate(date.getFullYear())}
                            >
                                {date.getFullYear()}
                            </button>
                        </div>
                    </li>
                </ul>
                {data && data ? (
                    <div className="block-content block-content-full">
                        <ResponsiveContainer height={300} key={"ativos"}>
                            <AreaChart
                                width={400}
                                height={400}
                                data={data}
                                margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
                            >
                                <XAxis dataKey="name" />
                                <Tooltip />
                                <Area
                                    type="monotone"
                                    dataKey={"novos_usuarios"}
                                    stroke={reportHelper.colors[6]}
                                    fill={reportHelper.colors[6]}
                                />
                                <Area
                                    type="monotone"
                                    dataKey={"acessos"}
                                    stroke={reportHelper.colors[5]}
                                    fill={reportHelper.colors[5]}
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}
